import { Box, Icon, Tab } from '@chakra-ui/react';
import React from 'react';

import { Maybe } from '../../../../types/dashboard-core-gqlTypes.generated.d';
import { insightKeyToConfig } from '../constants';
import { FiLayers } from 'react-icons/fi';

import '../../styles/common.scss';

export const InsightsViewTab = ({
  label,
  isHighlighted,
  onClick = () => null,
}: {
  label: string;
  isHighlighted: boolean;
  onClick?: () => void;
}) => {
  return (
    <Tab
      _selected={{ fontWeight: 'bold', borderBottom: '2px' }}
      pl="0"
      pr="0"
      minW="100px"
      mr={10}
      onClick={onClick}
    >
      {isHighlighted ? <span style={{ color: 'red' }}>{label}</span> : label}
    </Tab>
  );
};

const InsightsGridItemText = ({
  insightsKey,
  formattedValue = null,
}: {
  insightsKey: keyof typeof insightKeyToConfig;
  formattedValue?: Maybe<string>;
}) => {
  const { label, icon } = insightKeyToConfig[insightsKey];
  return (
    <>
      <Box fontSize="16px" color="black" fontWeight="bold" mb="5px">
        {icon && (
          <span>
            <Icon as={icon} />
          </span>
        )}{' '}
        {label}
      </Box>
      <Box fontSize="20px">{formattedValue}</Box>
    </>
  );
};

/**
 * Helper for a GridItem card for the insights view
 */
export const InsightsGridItemCard = ({
  insightsKey,
  formattedValue = null,
}: {
  insightsKey: keyof typeof insightKeyToConfig;
  formattedValue?: Maybe<string>;
}) => {
  const gridItemProps = {
    height: '100%',
    border: '1px solid #e3e3e3',
    padding: '20px 35px',
  };
  return (
    <Box {...gridItemProps}>
      <InsightsGridItemText
        insightsKey={insightsKey}
        formattedValue={formattedValue}
      />
    </Box>
  );
};

const ConcentrationLimitsDetailText = ({
  label,
  formattedValue = null,
}: {
  label: string;
  formattedValue?: Maybe<string>;
}) => {
  return (
    <>
      <Box fontSize="16px" fontWeight="bold" mb="5px">
        <Icon as={FiLayers} />
        &nbsp;{label}
      </Box>
      <Box fontSize="20px">{formattedValue}</Box>
    </>
  );
};

/**
 * Helper for a GridItem card for the concentration limits detail view
 */

export const ConcentrationLimitsDetailCard = ({
  label,
  formattedValue = null,
}: {
  label: string;
  formattedValue?: Maybe<string>;
}) => {
  const gridItemProps = {
    height: '100%',
    border: '1px solid #e3e3e3',
    padding: '20px 35px',
  };
  return (
    <Box {...gridItemProps}>
      <ConcentrationLimitsDetailText
        label={label}
        formattedValue={formattedValue}
        key={label}
      />
    </Box>
  );
};
